import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import Header from './Header';
import PetitionHighlights from './PetitionHighlights';
import {
  PageWrapper,
} from '../styles/shared';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120px 24px 60px;
  text-align: center;
  animation: ${fadeIn} 0.5s ease;
`;

const Code = styled.div`
  font-size: clamp(6rem, 20vw, 10rem);
  font-weight: 900;
  line-height: 1;
  letter-spacing: -4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 16px;
  user-select: none;
`;

const Title = styled.h1`
  font-size: 1.6em;
  font-weight: 700;
  color: white;
  margin-bottom: 12px;
`;

const Subtitle = styled.p`
  font-size: 1em;
  color: rgba(255, 255, 255, 0.6);
  max-width: 420px;
  line-height: 1.6;
  margin-bottom: 40px;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
`;

const PrimaryBtn = styled.button`
  padding: 13px 28px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 0.95em;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
  }
`;

const SecondaryBtn = styled.button`
  padding: 13px 28px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  font-size: 0.95em;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.18);
  }
`;

const HighlightsWrapper = styled.div`
  width: 100%;
  padding: 0 40px 60px;
  box-sizing: border-box;

  @media (max-width: 768px) { padding: 0 16px 40px; }
`;

const HighlightsTitle = styled.h2`
  color: rgba(255,255,255,0.7);
  font-size: 0.95em;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;
  margin-bottom: 20px;
`;

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <PageWrapper>
      <Header />
      <Content>
        <Code>404</Code>
        <Title>Page not found</Title>
        <Subtitle>
          The page you're looking for doesn't exist or may have been moved.
          Try searching for a petition or head back home.
        </Subtitle>
        <ButtonRow>
          <PrimaryBtn onClick={() => navigate('/')}>Go to Homepage</PrimaryBtn>
          <SecondaryBtn onClick={() => navigate('/petitions/open')}>Browse Open Petitions</SecondaryBtn>
        </ButtonRow>
      </Content>

      <HighlightsWrapper>
        <HighlightsTitle>While you're here, explore these petitions</HighlightsTitle>
        <PetitionHighlights />
      </HighlightsWrapper>

    </PageWrapper>
  );
};

export default NotFoundPage;
